import Image from '@/src/components/CustomImage'
import React from 'react'
import styles from './index.module.scss'

interface Section2Props {
  message: {
    __solution: string
    __shipments: string
    __buildTracking: string
    __buildatracking: string
  }
}

const Section2: React.FC<Section2Props> = ({ message }) => {
  return (
    <section className={styles.section2}>
      <div className={styles.container}>
        <div className={styles.boxLeft}>
          <Image
            data-yqrole="img"
            width={675}
            height={433}
            src="/assets/images/api/Part2_zh.png"
            className={styles.imgResponsive}
            alt="BG"
          />
        </div>
        <div className={styles.boxRight}>
          <h2 dangerouslySetInnerHTML={{ __html: message.__solution }} />
          <div className={styles.solutionDescription}>
            <ul>
              <li>{message.__shipments}</li>
              <li>{message.__buildTracking}</li>
              <li>{message.__buildatracking}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Section2
